import React, { useMemo, useState } from 'react'
import { Card, PageTitle, SearchField, StatusBadge, formatDate } from '../components/Ui'
import { portfolios, reviews } from '../data/adminExtendedData'
import { portfolioOperations } from '../data/parityDetailData'
import { moderationCases } from '../data/moderationData'

function moderationFor(type, item) {
  const targetType = type === 'portfolios' ? 'PORTFOLIO' : 'REVIEW'
  return moderationCases.find((entry) => entry.targetType === targetType && entry.targetId === item.id) || null
}

export default function UserContentManagement({ type, navigate }) {
  const isPortfolio = type === 'portfolios'
  const source = isPortfolio ? portfolios : reviews
  const [search, setSearch] = useState('')
  const rows = useMemo(() => source.filter((item) => {
    const haystack = isPortfolio
      ? [item.title, item.director, item.category].join(' ')
      : [item.reviewer, item.director, item.orderNo, item.content].join(' ')
    return !search || haystack.toLowerCase().includes(search.toLowerCase())
  }), [source, search, isPortfolio])

  return <>
    <PageTitle
      eyebrow={isPortfolio ? 'DIRECTOR CONTENT' : 'MEMBER CONTENT'}
      title={isPortfolio ? '디렉터 포트폴리오 조회' : '이용자 후기·신고'}
      description={isPortfolio
        ? '디렉터가 직접 등록한 포트폴리오를 조회하고 공개 상태·권리·신고 이슈를 사후 관리합니다. 관리자가 포트폴리오를 대신 등록하지 않습니다.'
        : '실제 거래 이용자가 작성한 후기를 조회하고 신고·블라인드 등 사후 관리만 수행합니다. 관리자가 후기를 새로 작성하지 않습니다.'}
      actions={<button className="button soft" onClick={() => navigate('/content/moderation')}>블라인드·삭제 관리</button>}
    />
    <div className="admin-section-callout"><div><strong>{isPortfolio ? '등록 주체: 디렉터' : '등록 주체: 이용자'}</strong><span>관리자는 원본 작성자가 아니며 조회·노출 상태·신고 처리 역할만 담당합니다.</span></div><span className="admin-owner-label">조회·사후관리</span></div>
    <Card className="table-card">
      <div className="table-toolbar"><SearchField value={search} onChange={setSearch} placeholder={isPortfolio ? '포트폴리오명, 디렉터, 카테고리 검색' : '작성자, 디렉터, 주문번호, 후기 검색'} /></div>
      <div className="table-result-bar"><span>검색 결과 <strong>{rows.length}</strong>건</span><small>행을 선택하면 상세·사후관리 정보를 확인합니다.</small></div>
      <div className="table-scroll"><table className="data-table"><thead><tr>{isPortfolio
        ? ['포트폴리오','디렉터','카테고리','미디어','공개 권한','노출 상태','조회','수정일'].map((label) => <th key={label}>{label}</th>)
        : ['작성자 / 주문','디렉터','평점','이미지','노출 상태','신고 사유','작성일'].map((label) => <th key={label}>{label}</th>)}</tr></thead><tbody>
        {rows.map((item) => {
          const moderation = moderationFor(type, item)
          if (isPortfolio) {
            const ops = portfolioOperations[item.id]
            return <tr key={item.id} onClick={() => navigate(`/content/portfolios/${item.id}`)}><td><strong>{item.title}</strong><small>{item.id}</small></td><td>{item.director}</td><td>{item.category}</td><td>{item.mediaCount}개</td><td>{ops?.rightsConfirmed ? '확인' : '확인 필요'}</td><td>{moderation ? <StatusBadge status={moderation.moderationStatus} /> : <StatusBadge status={item.status} />}</td><td>{item.viewCount.toLocaleString('ko-KR')}</td><td>{formatDate(item.updatedAt, true)}</td></tr>
          }
          return <tr key={item.id} onClick={() => navigate(`/content/reviews/${item.id}`)}><td><strong>{item.reviewer}</strong><small>{item.orderNo}</small></td><td>{item.director}</td><td>{'★'.repeat(item.rating)} <small>{item.rating}.0</small></td><td>{item.imageCount}개</td><td>{moderation ? <StatusBadge status={moderation.moderationStatus} /> : <StatusBadge status={item.status} />}</td><td>{item.reportReason || '-'}</td><td>{formatDate(item.createdAt, true)}</td></tr>
        })}
      </tbody></table></div>
    </Card>
  </>
}
